/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "@/src/components/Form/Common/SummaryDetailsItem/SummaryDetailsItem";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type TerminationProps = {
  product: AbstractCase;
};

const Termination = ({ product }: TerminationProps) => {
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}>Arbeitsverhältnis</Typography>
      </Grid>
      <SummaryDetailsItem caseData={product} fieldType={"dateMY"} fieldPath={"employedSince"} />
      <SummaryDetailsItem caseData={product} fieldType={"money"} fieldPath={"grossSalary"} />
      <SummaryDetailsItem caseData={product} fieldPath={"jobDescription"} />
      <SummaryDetailsItem caseData={product} fieldPath={"numberOfEmployees"} />
      <SummaryDetailsItem caseData={product} fieldPath={"worksCouncil"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.name"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.address.streetAddress"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.address.postalCode"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.address.addressLocality"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.address.postOfficeBoxNumber"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.address.postOfficeBoxPostalCode"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.address.postOfficeBoxAddressLocality"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.mainEmail.email"} />
      <SummaryDetailsItem caseData={product} fieldPath={"employerOrganization.telephone"} />
    </>
  );
};

export default Termination;
